import { Suspense } from 'react'

import type { RouteObject } from 'react-router'
import { Outlet } from 'react-router-dom'

import type { InjectedAppProps } from '../server/types/server.types.js'

import { memberSettingsRoutes } from './memberSettingsRoutes.js'
import { messagingRoutes } from './messagingRoutes.js'
import { moderationRoutes } from './moderationRoutes.js'

export const createPublicRoutes = (
  injectedAppProps: InjectedAppProps,
): RouteObject => ({
  path: '*',
  async lazy() {
    const { SlateApp } = await import('../client/SlateApp.js')
    const { RouterErrorBoundary } = await import(
      '../client/components/Error/RouterErrorBoundary.js'
    )

    return {
      element: (
        <SlateApp
          networkId={injectedAppProps?.network?.id}
          networkExtraProperties={injectedAppProps?.network?.extraProperties}
          memberId={injectedAppProps?.authMember?.id}
        >
          <Suspense fallback={<></>}>
            <Outlet />
          </Suspense>
        </SlateApp>
      ),
      errorElement: <RouterErrorBoundary />,
    }
  },
  children: [
    messagingRoutes,
    {
      path: 'oauth/authorize',
      async lazy() {
        const { OAuth } = await import('../client/components/OAuth/OAuth.js')

        return { Component: OAuth }
      },
    },
    moderationRoutes,
    memberSettingsRoutes,
    {
      path: '*',
      async lazy() {
        const { SpaceRoutes } = await import(
          '../client/components/SpaceRoutes.component.js'
        )

        return {
          element: (
            <SpaceRoutes
              networkName={injectedAppProps?.network?.name}
              headerDisabled={
                injectedAppProps?.network?.navigationSlates?.headerDisabled
              }
            />
          ),
        }
      },
    },
  ],
})
